import {CARTE, NAVY, TEXTE, TEXTE_SECONDAIRE, TITRE_SECTION} from '../../tokens.js';

// Styles `sx` communs aux blocs du Dashboard (valeurs exactes de Dashboard.dc.html).

export const carteSx = {
    backgroundColor: CARTE.fond,
    border: `1px solid ${CARTE.bordure}`,
    borderRadius: `${CARTE.radius}px`,
    boxShadow: CARTE.ombre,
};

export const lienCarteSx = {
    ...carteSx,
    display: 'flex',
    flexDirection: 'column',
    textDecoration: 'none',
    color: TEXTE,
    '&:hover': {borderColor: NAVY},
    '&:focus-visible': {outline: `2px solid ${NAVY}`, outlineOffset: 2},
};

/** Libellé de carte (12 px, 700, majuscules, .12em, gris). */
export const libelleCarteSx = {
    display: 'flex', alignItems: 'center', gap: '8px', fontSize: 12, fontWeight: 700,
    letterSpacing: '.12em', textTransform: 'uppercase', color: TITRE_SECTION,
};

/** Titre de section (12 px, 800, majuscules, .14em, navy). */
export const titreSectionSx = {m: 0, fontSize: 12, fontWeight: 800, letterSpacing: '.14em', textTransform: 'uppercase', color: NAVY};

export const enteteSectionSx = {display: 'flex', alignItems: 'baseline', gap: '12px', p: '16px 24px', borderBottom: '1px solid #EEF1F4'};

export const sousTitreSx = {fontSize: 12, color: TEXTE_SECONDAIRE};

export const boutonPiluleSx = {
    display: 'inline-flex', alignItems: 'center', gap: '8px', height: 36, px: '14px', border: '1px solid #D5DAE1',
    borderRadius: '999px', backgroundColor: '#FFFFFF', font: 'inherit', fontSize: 13, fontWeight: 600, color: TEXTE, cursor: 'pointer',
    '&:disabled': {borderColor: '#E3E7EC', color: '#9A9A9A', cursor: 'default'},
};
